module.exports = require("./ast.d.ts");